import Q4_1 from './Q4_1';

export default Q4_1;
